import PropTypes from 'prop-types';
import { Modal, Title } from '@mantine/core';
import { radius } from 'theme/radius';
import { shadows } from 'theme/shadows';
import { coral } from 'theme/colors';
import KayakWidget from '../widgets/KayakWidget';

const KayakDialog = ({ open, onClose }) => (
  <Modal
    opened={open}
    onClose={onClose}
    size="lg"
    radius={radius.surface}
    shadow={shadows.modal}
    aria-labelledby="kayak-dialog-title"
    title={
      <Title order={3} c={coral[6]}>
        Kayak Flight Search
      </Title>
    }
  >
    <KayakWidget open={open} />
  </Modal>
);

KayakDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default KayakDialog;
